import React, { useContext, useEffect, useState } from "react";
import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import ApiUri from "../../../../api/api-uri";
import API from "../../../../api/api";
import { GlobalLoaderContext } from "../../../../context/global-loader";
import {
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Skeleton,
  Stack,
  TextField,
} from "@mui/material";
import { SnackbarContext } from "../../../../context/snackbar";
import { Composition } from "../../../../models/composition/composition";
import { Song } from "../../../../models/song/song";
import { PlayCircleOutline } from "@mui/icons-material";
import CustomToolbar from "../../../../components/layout/titles/CustomToolbar";
import ActionButtonSmall from "../../../../components/layout/buttons/action-button-small";
import Loader from "../../../../components/loader";
import Compositions from "../../../../enums/compositions";
import { AuthContext } from "../../../../context/auth";
import ArtworkCard from "../about-song-modal/artwork-card";
import SongsCard from "../about-song-modal/songs-card";
import EditISRCAlternateForm from "./EditISRCAlternateForm";
import { Platform } from "../../../../models/publishing/platform";

const formatDate = (date) => {
  const parsedDate = new Date(date);

  const day = String(parsedDate.getDate()).padStart(2, "0");
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Note: Month is 0-based, so we add 1.
  const year = parsedDate.getFullYear();
  const hours = String(parsedDate.getHours()).padStart(2, "0");
  const minutes = String(parsedDate.getMinutes()).padStart(2, "0");

  const formattedDateTime = `${day}/${month}/${year}, ${hours}:${minutes}`;
  return formattedDateTime;
};

const Transition = React.forwardRef(function Transition(
  // made the children prop required
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface AddSongIdModalProps {
  modalOpened: boolean;
  handleClose: () => void;
  platform: Platform;
  composition: any;
  setComposition: React.Dispatch<any>;
}

interface Note {
  composition_id: number;
  created_at: string;
  created_by: string;
  id: number;
  note: string;
  status: string;
  updated_at: string;
}

export default function AddSongIdModal({
  modalOpened,
  handleClose,
  platform,
  composition,
  setComposition,
}: AddSongIdModalProps) {
  const { startGlobalLoader, stopGlobalLoader } =
    useContext(GlobalLoaderContext);
  const { user } = useContext(AuthContext);
  const { initSnackbarError, initSnackbarSuccess } =
    useContext(SnackbarContext);

  // useEffect(() => {
  //   startGlobalLoader();
  //   API.get(ApiUri.COMPOSITION + "/" + platformId).then(
  //     (response) => {
  //       setComposition(response.data);
  //       stopGlobalLoader();
  //     },
  //     (err) => {
  //       stopGlobalLoader();
  //       initSnackbarError(err);
  //     },
  //   );
  // }, []);
  const foundPlatform = composition.composition_platforms.find(
    (compositionPlatform) => compositionPlatform.platform.id === platform.id,
  );
  const [songID, setSongID] = useState<string | null>(
    foundPlatform ? foundPlatform?.external_id : null,
  );

  const closeSongModal = () => {
    handleClose();
  };

  const handleSave = () => {
    startGlobalLoader();
    const payload = {
      external_id: songID,
    };
    API.put(ApiUri.COMPOSITION_PLATFORM + "/" + foundPlatform.id, payload).then(
      (response) => {
        stopGlobalLoader();
        setSongID(null);
        initSnackbarSuccess("Song ID added successfully");
        setComposition(null);
        handleClose();
      },
      (error) => {
        stopGlobalLoader();
        initSnackbarError(error);
      },
    );
  };

  const handleFieldChange = (event: any) => {
    let { value } = event.target;
    setSongID(value);
  };

  return (
    <Dialog
      open={modalOpened}
      onClose={closeSongModal}
      TransitionComponent={Transition}
      maxWidth="sm"
    >
      <AppBar position="sticky">
        <CustomToolbar>
          <Typography variant="h6" flex={1}>
            Add Song ID
          </Typography>
          <IconButton
            color="inherit"
            onClick={closeSongModal}
            aria-label="close"
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </CustomToolbar>
      </AppBar>

      <Stack
        paddingX={4}
        paddingBottom={4}
        paddingTop={6}
        direction="column"
        spacing={4}
        alignItems={"center"}
      >
        <TextField
          fullWidth
          label="Song ID"
          value={songID || ""}
          name="songID"
          onChange={handleFieldChange}
        />
        <ActionButtonSmall onClick={handleSave}>Save</ActionButtonSmall>
      </Stack>
    </Dialog>
  );
}
